"use strict";

/**
*  Встроенная подсказка
*
* @class WebAccess.components.notifications.InlineHint
* @extends BaseObject
* @param {object} [opt_settings] Параметры подсказки
* @param {Integer} [opt_dialogId] ИД подсказки
* @since 5.0.0.7300
*
* @example
* var hint = new WA.CMP.NTF.InlineHint()
* hint.showError("Hello world");
*/
(function (global) {
  var InlineHint = BaseObject.extend({
    _dialogId: 0,
    _customDialogId: false,
    init: function (opt_settings, opt_dialogId) {
      this._super(opt_settings);
      this._dialogId = opt_dialogId;
      if (opt_dialogId) this._customDialogId = true;
      if ($.isPlainObject(opt_settings)) {
        $.extend(this, opt_settings);
      };

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    className: 'InlineHint',

    /**
    * Показать встроенную подсказку с предупреждением.
    *
    * @function  WebAccess.components.notifications.InlineHint#showWarning
    * @param {string} title Основной текст предупреждения
    * @param {string} [message] Информационный текст, объясняющий суть предупреждения
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return  {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.0.0.7300
    */
    showWarning(title, message, inlineHintPriority) {     
      const inlineHintParams = {
        message,
        priority: inlineHintPriority,
        type: MESSAGE_TYPE.WARNING,
      };    
      return this.show(title, inlineHintParams);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать встроенную подсказку с текстом ошибки.
    *
    * @function  WebAccess.components.notifications.InlineHint#showError
    * @param {string} title Основной текст ошибки
    * @param {string} [message] Информационный текст, объясняющий ошибку
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    */
    showError(title, message, inlineHintPriority) {
      const inlineHintParams = {
        message,
        priority: inlineHintPriority,
        type: MESSAGE_TYPE.ERROR,
      };
      return this.show(title, inlineHintParams);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Показать  встроенную подсказку с информационным сообщением.
    *
    * @method WebAccess.components.notifications.InlineHint#showInfo
    * @param {string} title Основной текст сообщения
    * @param {string} [message] Информационный текст, объясняющий суть сообщения
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.1.0.1511
    */
    showInfo(title, message, inlineHintPriority) {
      const inlineHintParams = {
        message,
        priority: inlineHintPriority,
        type: MESSAGE_TYPE.INFO,
      };
      return this.show(title, inlineHintParams);
    },

    /**
    * Показать подсказку в диалоге
    * @function WebAccess.components.notifications.InlineHint#showInDialog
    * @param {string} dialogId Идентификатор целевого диалога
    * @param {string} title Основной текст сообщения
    * @param {string} [message] Информационный текст
    * @param {MESSAGE_TYPE} [messageType] Тип сообщения
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint
    */
    showInDialog(dialogId, title, message, messageType, inlineHintPriority) {
      this._dialogId = dialogId;
      this._customDialogId = true;
      const inlineHintParams = {
        message,
        priority: inlineHintPriority,
        type: messageType,
      };
      return this.show(title, inlineHintParams);
    },

    _updateContext: function () {
      if (this._customDialogId) return;

      this._dialogId = null;

      var jDialog = $('.ui-dialog-content').last();
      if (!jDialog.length) return;
      var jDialogContent = jDialog.children();
      if (jDialogContent.length) {
        this._dialogId = jDialogContent.attr('id');
        if (typeof this._dialogId !== 'undefined') {
          this._dialogId = this._dialogId.replace('dialog_content_', '');
        }
      }
    },

    /**
     * Показать встроенную подсказку.
     *
     * @method WebAccess.components.notifications.InlineHint#show
     * @param {string} title Основной текст сообщения
     * @param {string} [params = {} || ''] Дополнительные параметры или, в устаревшем варианте, информационный текст
     * @param {string} [params.message= ''] Информационный текст
     * @param {string} [params.priority = INLINE_HINT_PRIORITY.SECONDARY] Приоритет встроенной подсказки
     * @param {string} [params.type = MESSAGE_TYPE.ERROR] Тип сообщения
     * @param {MESSAGE_TYPE} [messageType = MESSAGE_TYPE.ERROR] Тип сообщения @deprecated since 5.6.0.9069
     * @param {INLINE_HINT_PRIORITY} [inlineHintPriority = INLINE_HINT_PRIORITY.SECONDARY] Приоритет встроенной
     * подсказки @deprecated since 5.6.0.9069
     * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
     */
    show(title, params = {}, messageType = MESSAGE_TYPE.ERROR, inlineHintPriority = INLINE_HINT_PRIORITY.SECONDARY) {
      // В версии 5.7 метод show можно будет вызвать только так: show(title, params);
      if (typeof params !== 'object' || arguments.length > 2) {
        // Приводим аргументы в современный вид и сообщаем о том, что по-старому пользоваться не рекомендуется
        this._warnAboutDeprecatedMethod('WA.CMP.NTF.InlineHint.show', 'Устаревший вариант использования аргументов метода {0}');
        let message = (typeof params === 'string') ? params : '';
        params = {
          message,
          priority: inlineHintPriority,
          type: messageType,
        };
      } else {
        // Устанавливаем значения по умолчанию.
        if (!Object.values(INLINE_HINT_PRIORITY).includes(params.priority)) {
          params.priority = INLINE_HINT_PRIORITY.SECONDARY;
        }
        if (!Object.values(MESSAGE_TYPE).includes(params.type)) {
          params.type = MESSAGE_TYPE.ERROR;
        }
      }

      this._updateContext();

      // Пробуем распарсить JSON, на случай, если в метод первым параметром был передан JSON-объект
      try {
        let jsonObject = JSON.parse(title);
        if (jsonObject.Message) {
          title = jsonObject.Message;
        }
      } catch (e) {
        // Игнорируем, если title не является JSON-объектом
      }

      this.hide(params.priority);

      title.trim().replace(/\n/g, '<br>').replaceAll("\u0026quot;", '"');

      const splitterIndex = title.toString().indexOf('^');
      if (splitterIndex !== -1) {
        params.message = title.substring(splitterIndex + 1).fromISBuilderToNormal();
        title = title.substring(0, splitterIndex);
      }

      // Если после всех преобразований title пустой - выходим из метода.
      if (!title) {
        return this;
      }

      let cssClass;
      switch (params.type) {
        case MESSAGE_TYPE.ERROR:
          cssClass = 'error';
          break;
        case MESSAGE_TYPE.WARNING:
          cssClass = 'highlight';
          break;
        case MESSAGE_TYPE.INFO:
          cssClass = 'info';
      }
      if (params.priority === INLINE_HINT_PRIORITY.SECONDARY) {
        cssClass += ' inline-hint_priority_secondary';
      }

      const templateParams = {
        type: (params.type === MESSAGE_TYPE.ERROR) ? 'err' : 'wrn',
        typeClass: cssClass,
        message: title,
        details: params.message,
      };

      WA.TMPL.render('components/inlineHint.compile.html', templateParams).done((html) => {
        let jContainer;

        // Находим контейнер ошибки в DOM, в которм будем рендерить inline-hint
        const possibleContainers = [
          '#dialog_content_' + this._dialogId, // В диалоге
          '.npocomputer-previewdoc-errors-place-holder', // В предпросмотре
          '#ctl00_MainContent_ErrorContainer', // В карточках и в МД
          '[name="ErrorControl"]', // В проводнике
          '#right_column', // Неизвестно где, оставлено лишь бы чего не сломать
        ];
        for (let i = 0; i < possibleContainers.length; i++) {
          jContainer = $(possibleContainers[i]);
          if (jContainer.length) break;
        }

        // Добавляем inline-hint с низким приоритетом после inline-hint'а с высоким приоритетом
        const jErrorContainerPrimary = jContainer.find('.error_div_msg').not('.inline-hint_priority_secondary');
        if (jErrorContainerPrimary.length) {
          jErrorContainerPrimary.after(html);
        } else {
          jContainer.prepend(html);
        }

        // Получаем только что добавленный inline-hint
        let jCurrentErrorContainer;
        switch (params.priority) {
          case INLINE_HINT_PRIORITY.PRIMARY:
            jCurrentErrorContainer = jContainer.find('.error_div_msg').not('.inline-hint_priority_secondary');
            break;
          case INLINE_HINT_PRIORITY.SECONDARY:
            jCurrentErrorContainer = jContainer.find('.inline-hint_priority_secondary');
        }

        // Навешиваем событые удаления inline-hint при нажатии на крестик
        jCurrentErrorContainer.find('.error_close').on('click', () => {

          this.hide(params.priority);
        });
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть последнее открытое сообщение.
    *
    * @function WebAccess.components.notifications.InlineHint#hide
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.0.0.7300
    */
    hide(inlineHintPriority = null) {
      switch (inlineHintPriority) {
        case INLINE_HINT_PRIORITY.PRIMARY:
          $('.error_div_msg').not('.inline-hint_priority_secondary').remove();
          break;
        case INLINE_HINT_PRIORITY.SECONDARY:
          $('.inline-hint_priority_secondary').remove();
          break;
        default:
          global.InlineHint.hideAll();
      }
      return this;
    },

  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~!!~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.InlineHint = InlineHint;

  /**
  * Скрыть все сообщения.
  *
  * @function WebAccess.components.notifications.InlineHint#hideAll
  * @static
  * @since 5.0.0.7300
  */
  global.InlineHint.hideAll = function () {
    $(".error_div_msg").add('#error_container').remove();
    $(".fake.error_content_padding").remove();
    $(".error_content_padding").addClass('error_content_init_padding').removeClass('error_content_padding');
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


})(window.WebAccess.components.notifications);